import React, { Fragment, useCallback,useEffect, useMemo, useState } from 'react';
import { MessageSquare } from 'react-feather';
import Arrow from '@assets/images/dashboard/arrow.svg';
import List from '@assets/images/dashboard/list.svg';
import LogOut from '@assets/images/dashboard/logout.svg';
import OpenDoor from '@assets/images/dashboard/opendoor.svg';
import LogoLetmeup from '@assets/images/Logo_letmeupBlack.svg';
import Menu from '@assets/images/menuBlack.svg';
import User from '@assets/images/UserCircle.svg';
import SendOpinionModal from '@components/modal/SendOpinionModal';
import SocketControlModal from '@components/modal/SocketControlModal';
import { deleteLogout } from '@lib/api/v2/auth';
import useHandleAPICall from '@lib/hooks/useHandleAPICall';
import useHandleError from '@lib/hooks/useHandleError';
import useKioskOption from '@lib/hooks/useKioskOption';
import { openDoor } from '@lib/socket';
import useAppStore from '@store/useAppStore';
import { media } from '@styles/mediaQuery';
import { getAllToken, removeToken } from '@util/token';
import styled, { css } from 'styled-components';

const Divider = styled.div`
  width: 90%;
  background: ${({ theme }) => theme.neutralGray[200]};
  height: 1px;
`;

const ToggleMenu = styled.div`
  position: fixed;

  top: 3.5rem;
  right: 1rem;

  display: flex;
  flex-direction: column;

  width: 14rem;

  border-radius: 1rem;
  overflow: hidden;
  z-index: 450;
  background: white;
  box-shadow: 0px 0px 24px 0px #00000029;

  transition: opacity 0.15s ease-in-out, right 0.2s ease-in-out;

  .list-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
  }

  ${({ enabled }) =>
    enabled
      ? css``
      : css`
          z-index: -1;
          right: -16rem;
          opacity: 0;
        `}
`;

const MenuListItem = styled.div`
  display: grid;
  grid-template-columns: 2rem auto;
  align-items: center;
  padding: 0.75rem;
  background: white;
  color: ${({ theme }) => theme.neutralGray[500]};
  font-size: 1rem;
  border-radius: 0.5rem;
  width: 100%;
  font-weight: 600;

  &:hover {
    filter: brightness(95%);
  }
`;

const StyledMenuHandler = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.5rem;
  gap: 0.5rem;

  .merchant-name {
    font-size: 1rem;
    font-weight: 600;
  }

  &:hover {
    backdrop-filter: brightness(95%);
  }
`;

const ResponseMerchantName = styled.div`
  color: #2b2b2b;
  font-size: 16px;
  font-weight: 600;
  ${media.desktop`
    padding: 1rem;
    background-color: #f1f3f6;
    display: flex;
    color: #686c71;
    word-break: keep-all;
    > div {
      &:first-child {
        margin-right: 0.5rem;
      }
    }
  `}
`;

const Container = styled.div`
  .nav-right {
    margin-right: 0 !important;
  }
  .nav-menus {
    margin-right: 0 !important;
    .media-body {
      padding: 0.5rem;
      &:hover {
        background-color: #f1f3f6;
        border-radius: 0.41vw;
      }
    }
  }
  .profile-media img {
    width: 0.52vw !important;
    height: 0.31vw !important;
    margin-left: 0.2vw;
  }
  .profile-dropdown {
    width: 14rem;
    /* border-radius: 0.83vw !important; */
    border-radius: 1rem;
    padding: 0.41vw 0.41vw !important;
    box-shadow: 0px 0px 24px 0px #00000029;
    right: 1rem;
    /* top: 2.9vw !important; */
    /* right: 0 !important; */
    /* left: 1.53vw !important; */
    li {
      justify-content: flex-start;
      padding: 0.62vw 1.45vw;
      img {
        width: 0.93vw;
        margin-right: 0.41vw;
      }
      span {
        font-size: 0.93vw;
        font-weight: 600;
        color: #686c71 !important;
      }
      &:first-child {
        border-top: none !important;
      }
      &:hover {
        background-color: #f1f3f6;
        border-radius: 0.41vw;
      }
    }
    hr {
      margin: 0;
      width: 80%;
      border-top: 1px solid #dde4eb;
      margin-left: 10%;
    }
  }
  ${media.tablet`
    .profile-dropdown {
      position: fixed;
      border-radius: 4.44vw !important;
      padding: 0 !important;

      right: 1rem;
      li {
        padding: 4.72vw 8.88vw !important;

        img {
          width: 5vw;
          margin-right: 2.22vw;
        }
        span {
          font-size: 5vw;
        }
        &:nth-child(2) {
          border-top: none !important;
        }
        &:hover {
          background-color: #ffffff;
          border-radius: 0.41vw;
        }
      }
      hr {
        margin-left: 6.66vw;
      }
    }
  `}
`;

const MobileHeader = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .showMenu {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1rem;
    /* margin-right: 5vw; */
  }
  .logo {
    height: 1.5rem;
  }
  .user {
    width: 1.75rem;
  }
`;

const Rightbar = (props) => {
  const { createRequest } = useHandleAPICall();
  const { catchError } = useHandleError();

  const { merchantData, userPhoneNumber } = useAppStore();
  const {
    kioskOptions,
    usingLegacyMultiKiosk,
    usingMultiKiosk,
    legacyMultiKioskFloor,
    handleOpenDoor,
    handleOpenDoorLegacy,
  } = useKioskOption();

  const [toggleMenuEnabled, setToggleMenuEnabled] = useState(false);
  const [isDoorModal, setIsDoorModal] = useState(false);
  const [isOpinionModal, setIsOpinionModal] = useState(false);
  const [name, setName] = useState('');
  const [merchantCode, setMerchantCode] = useState('');

  const { screenType } = props;

  const { adminToken, userToken, merchantToken } = getAllToken();

  const handleLogout = async () => {
    try {
      if (!props) return;
      await createRequest(deleteLogout);
    } catch (error) {
      catchError(error);
    }
  };

  const handleClick = useCallback(
    () => setToggleMenuEnabled(!toggleMenuEnabled),
    [toggleMenuEnabled],
  );

  const goToMerchantList = () => {
    removeToken(['merchantToken', 'merchantRefreshToken']);
    if (UserType.merchantUserV2) {
      localStorage.setItem('level', 'user');
      window.location.href = `${process.env.PUBLIC_URL}/select-merchant`;
      return;
    }
    localStorage.setItem('level', 'admin');
    window.location.href = `${process.env.PUBLIC_URL}/backoffice/merchant/list`;
  };

  const UserType = useMemo(() => {
    return {
      adminMerchant: !!merchantToken && !!adminToken,
      merchantUserV1: !!merchantToken && !userToken && !!userPhoneNumber,
      merchantUserV2: !!merchantToken && !!userToken,
      userV2: !!userToken && !merchantToken,
      merchant: !!merchantToken && !userToken,
      admin: adminToken && !merchantToken,
    };
  }, [userToken, merchantToken, adminToken, userPhoneNumber]);

  const MenuHandler = useMemo(() => {
    // return (
    //   <div className="media profile-media" style={{ alignItems: 'center', width: 'max-content' }}>
    //     <div>
    //       <div style={{ display: 'flex' }} className="media-body" onClick={() => handleClick()}>
    //         <span>
    //           {name ? name : ''}{' '}
    //           {merchantCode && (
    //             <>
    //               <small>({merchantCode})</small>
    //             </>
    //           )}
    //         </span>
    //         <span>
    //           <img src={Arrow} alt="더보기" />
    //           {/* <i style={{ marginLeft: "15px" }} className="middle fa fa-angle-down"></i> */}
    //         </span>
    //       </div>
    //     </div>
    //   </div>
    // );
    return (
      <StyledMenuHandler onClick={handleClick}>
        <span className="merchant-name">{name || ''}</span>
        <span>{merchantCode && <>({merchantCode})</>}</span>
        <span>
          <img src={Arrow} alt="더보기" />
        </span>
      </StyledMenuHandler>
    );
  }, [handleClick, name, merchantCode]);

  const moveToDashBoard = () => {
    if (UserType.merchant)
      return (window.location.href = `${process.env.PUBLIC_URL}/admin/dashboard`);
    if (UserType.merchantUserV1 || UserType.merchantUserV2)
      return (window.location.href = `${process.env.PUBLIC_URL}/dashboard`);
    if (UserType.userV2)
      return (window.location.href = `${process.env.PUBLIC_URL}/select-merchant`);
  };

  useEffect(() => {
    if (!props.data) return;
    if (UserType.merchantUserV1 || UserType.merchantUserV2) {
      if (!props?.data.userName) {
        setName(`${props.data.merchantName} - ${props.data.phoneNum?.slice(7, 11)} 님` || '');
      } else {
        setName(`${props.data.merchantName} - ${props.data.userName} 님` || '');
      }
      return;
    }
    if (UserType.userV2) return setName(`${props.data.phoneNum?.slice(7, 11)} 님` || '');
    if (UserType.merchant) {
      setName(props?.data?.merchantName || props.data.name);
      setMerchantCode(props.data.phoneNum || props.data.merchant_code);
      return;
    }
    if (UserType.admin) {
      setName('최고 관리자');
      return;
    }
  }, [props]);

  const hasAnyMultiKiosk = usingMultiKiosk || usingLegacyMultiKiosk;

  return (
    <Fragment>
      {isOpinionModal && (
        <SendOpinionModal isOpen={isOpinionModal} onClose={() => setIsOpinionModal(false)} />
      )}
      {isDoorModal && hasAnyMultiKiosk && (
        <SocketControlModal
          show={isDoorModal}
          onClose={setIsDoorModal}
          data={usingMultiKiosk ? kioskOptions : merchantData?.multiKioskFloor}
          usingLegacyMultiKiosk={usingLegacyMultiKiosk}
          usingMultiKiosk={usingMultiKiosk}
          kioskOptions={kioskOptions}
          legacyMultiKioskFloor={legacyMultiKioskFloor}
          handleOpenDoor={handleOpenDoor}
          handleOpenDoorLegacy={handleOpenDoorLegacy}
          kind="Door"
          // useNewSystem={usingMultiKiosk}
        />
      )}
      {screenType !== 'desktop' && (
        <MobileHeader>
          <div>
            <img
              className="showMenu"
              onClick={() => props.setIsShowSide(true)}
              src={Menu}
              alt="menu"
            />
            <img className="logo" src={LogoLetmeup} alt="LogoLetmeup" onClick={moveToDashBoard} />
          </div>
          {screenType === 'mobile' && (
            <div>
              <img className="user" onClick={() => handleClick()} src={User} alt="user" />
            </div>
          )}
          {screenType === 'tablet' && MenuHandler}
        </MobileHeader>
      )}

      <Container>
        {screenType === 'desktop' && MenuHandler}
        <div className="nav-right col-8 pull-right right-header p-0">
          <ul className="nav-menus">
            <li className="profile-nav onhover-dropdown p-0">
              <ToggleMenu enabled={toggleMenuEnabled}>
                {screenType !== 'desktop' && (
                  <ResponseMerchantName>
                    <div>
                      <img className="user" src={User} alt="user" />
                    </div>{' '}
                    <div>
                      {name ? name : ''}
                      {merchantCode && (
                        <>
                          <small>({merchantCode})</small>
                        </>
                      )}
                    </div>
                  </ResponseMerchantName>
                )}
                <div className="list-wrapper">
                  {UserType.merchant &&
                    !(UserType.merchantUserV1 || UserType.merchantUserV2) &&
                    (props && !hasAnyMultiKiosk ? (
                      <MenuListItem onClick={() => openDoor(props.mid)}>
                        <img src={OpenDoor} alt="OpenDoor" />
                        <span>문 열기</span>
                      </MenuListItem>
                    ) : (
                      <MenuListItem onClick={() => setIsDoorModal(true)}>
                        <img src={OpenDoor} alt="OpenDoor" />
                        <span>멀티 문열기</span>
                      </MenuListItem>
                    ))}
                  {(UserType.merchant || UserType.merchantUserV1 || UserType.merchantUserV2) && (
                    <MenuListItem
                      onClick={() => {
                        setToggleMenuEnabled(false);
                        setIsOpinionModal(true);
                      }}>
                      <MessageSquare size={18} color="#04c9db" />
                      <span>의견 보내기</span>
                    </MenuListItem>
                  )}
                  <Divider />
                  <MenuListItem onClick={handleLogout}>
                    <img src={LogOut} alt="logout" />
                    <span>로그아웃</span>
                  </MenuListItem>
                  {(UserType.merchantUserV2 || UserType.adminMerchant) && (
                    <>
                      <Divider />
                      <MenuListItem onClick={goToMerchantList}>
                        <img src={List} alt="list" />
                        <span>지점 리스트</span>
                      </MenuListItem>
                    </>
                  )}
                </div>
              </ToggleMenu>
              {/* <ul className="profile-dropdown onhover-show-div">
                {isMobile && (
                  <ResponseMerchantName>
                    <div>
                      <img className="user" src={User} alt="user" />
                    </div>{' '}
                    <div>
                      {name ? name : ''}
                      {merchantCode && (
                        <>
                          <small>({merchantCode})</small>
                        </>
                      )}
                    </div>
                  </ResponseMerchantName>
                )}
                {UserType.merchant &&
                  !(UserType.merchantUserV1 || UserType.merchantUserV2) &&
                  (props && !props.data.multiKioskFloor ? (
                    <li onClick={() => openDoor(props?.mid)}>
                      <img src={OpenDoor} alt="OpenDoor" />
                      <span>문 열기</span>
                    </li>
                  ) : (
                    <li onClick={() => setIsDoorModal(true)}>
                      <img src={OpenDoor} alt="OpenDoor" />
                      <span>멀티 문열기</span>
                    </li>
                  ))}
                <hr />
                <li onClick={handleLogout}>
                  <img src={LogOut} alt="logout" />
                  <span>로그아웃</span>
                </li>
                <hr />
                {(UserType.merchantUserV2 || UserType.adminMerchant) && (
                  <li onClick={goToMerchantList}>
                    <img src={List} alt="list" />
                    <span>지점 리스트</span>
                  </li>
                )}
              </ul> */}
            </li>
          </ul>
        </div>
      </Container>
    </Fragment>
  );
};
export default Rightbar;
